import { render, staticRenderFns } from "./transactionList.vue?vue&type=template&id=1d4b8ebc&scoped=true&"
import script from "./transactionList.vue?vue&type=script&lang=js&"
export * from "./transactionList.vue?vue&type=script&lang=js&"
import style0 from "./transactionList.vue?vue&type=style&index=0&id=1d4b8ebc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4b8ebc",
  null
  
)

export default component.exports